import { dataUrlToCanvas } from "../modelViews/GraficElementUtils";

export default class ConsumerImages {
  static imageInfos = new Map<string, { src: string; width: number; height: number }>();

  static getImageInfoSync(src: string): { width: number; height: number } | undefined {
    let src1 = src;
    if (src.length > 200) {
      src1 = src.substring(0, 200) + "..."; // no itx
    }

    let res = this.imageInfos.get(src1);
    return res;
  }

  static async loadImageInfoAsync(src: string): Promise<
    | "loaded" //no itx
    | "already loaded" //no itx
    | undefined
  > {
    let src1 = src;
    if (src.length > 200) {
      src1 = src.substring(0, 200) + "..."; // no itx
    }

    let res = this.imageInfos.get(src1);
    if (!res) {
      const image = await dataUrlToCanvas(src);
      if (image) {
        res = { src: src1, width: image.width, height: image.height };
        this.imageInfos.set(src, res);
      } else {
        return undefined;
      }
    } else {
      return "already loaded"; // no itx
    }
    return "loaded"; // no itx
  }
}
